<template>
  <q-dialog :visible="visible" title="导出" :width=" type ? '600px' : '500px'" @close="onCancel" :innerScroll="false" :loading="loading" @cancel="onCancel" @confirm="onConfirm">
    <el-form :model="form" ref="formRef" label-width="120px">
      <el-form-item label="请选择导出类型">
        <el-radio-group v-model="exportType">
          <template v-if="!type">
            <el-radio :label="1">列表数据导出</el-radio>
            <el-radio :label="2">模板样式数据导出</el-radio>
          </template>
          <template v-else>
            <el-radio :label="1">列表数据导出</el-radio>
            <el-radio :label="2">信息模板样式导出</el-radio>
            <el-radio :label="3">文案模板样式导出</el-radio>
          </template>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: 'RemoveToList',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      exportType: 1,
      form: {},
      finishExportType: 1,
    };
  },
  methods: {
    onCancel() {
      this.$emit('update:visible', false);
    },
    onConfirm() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.$emit('exportExcel', this.exportType);
        this.onCancel();
      }, 500);
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--mini .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 300px !important;

>>> .el-input
    width 300px !important;

.dialog-footer
  text-align: center
  margin-top: 30px
.tips
  color red
  padding-left 20px
</style>
